import { useEffect } from 'react';

export const useCustomEvent = (eventName: string, callback: (value: boolean) => void) => {
  useEffect(() => {
    const handleMessage = (event: Event) => {
      const customEvent = event as CustomEvent<boolean>;
      callback(customEvent.detail);
    };

    window.addEventListener(eventName, handleMessage);

    return () => {
      window.removeEventListener(eventName, handleMessage);
    };
  }, [callback, eventName]);
};

export const useExtendCustomEvent = <T>(eventName: string, callback: (value: T) => void) => {
  useEffect(() => {
    const handleEvent = (event: Event) => {
      const customEvent = event as CustomEvent<T>;
      callback(customEvent.detail);
    };

    window.addEventListener(eventName, handleEvent);

    return () => {
      window.removeEventListener(eventName, handleEvent);
    };
  }, []);
};

// Функция для отправки события (без изменений)
export const emitExtendCustomEvent = <T>(eventName: string, detail?: T) => {
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
};
